import React from "react";

import { useVerification } from "context/verificationContext";

// Top banner reminding logged-in, unverified users to verify their email.
// Renders nothing once the user is verified (or when logged out).
const VerifyEmailBanner = () => {
  const { gated, resend, cooldown, sending } = useVerification();

  if (!gated) return null;

  const label = sending
    ? "Sending..."
    : cooldown > 0
    ? `Resend in ${cooldown}s`
    : "Resend Verification";

  return (
    <div className="w-full bg-[#1CC300] text-white text-center py-2 px-4 text-sm font-medium">
      Please verify your email address to unlock all features.{" "}
      <button
        type="button"
        onClick={resend}
        disabled={cooldown > 0 || sending}
        className="underline font-semibold bg-transparent border-none text-white cursor-pointer disabled:opacity-70 disabled:cursor-not-allowed"
      >
        {label}
      </button>
    </div>
  );
};

export default VerifyEmailBanner;
